import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';

new Swiper('.bestsellers-carousel', {
// configure Swiper to use modules
  modules: [Navigation],
  centeredSlides: true,
  slidesPerView: 'auto',
  spaceBetween: 20,

  // Navigation arrows
  breakpoints: {
    992: {
      centeredSlides: false,
      navigation: {enabled: true},
    },
  },
  navigation: {
    enabled: false,
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});
